export const logs: ILogs = {
  '1': {
    id: '1',
    timestamp: 0,
    message: 'Log 1',
    source: 'context 1',
    verb: '',
    data: {},
  },
};
